import AbstractFilter from './AbstractFilter';

export default class StripTags extends AbstractFilter
{
    filter(value: any): string
    {
        if (value === null)
        {
            return '';
        }

        return value.toString().replace(/(<([^>]+)>)/ig, '');
    }
}